import React from 'react';
import { Link } from 'react-router-dom';
import image1 from '../images/demo/offset.jpg';

const Intro = () => {
    return (
        <section id="about" className="bg-white py-20 px-4 md:px-12 lg:px-24">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-12" data-aos="fade-up">
                {/* Image Section */}
                <div className="lg:w-1/2">
                    <img
                        src={image1}
                        alt="Offset Printing Machine"
                        className="w-full h-auto rounded-xl shadow-lg object-cover"
                    />
                </div>

                {/* Text Section */}
                <div className="lg:w-1/2" data-aos="zoom-in" data-aos-delay="500">
                    <h3 className="text-4xl text-blue-900 font-bold leading-tight mb-6">
                        Where Precision Meets Presentation
                    </h3>
                    <p className="text-lg text-gray-700 mb-4">
                        With over 20 years of experience, <span className="font-semibold">JSS The Print Zone</span> delivers high-quality printing and packaging solutions tailored for cosmetics, healthcare, and lifestyle brands.
                    </p>
                    <p className="text-lg text-gray-700 mb-4">
                        Our fully equipped in-house facility — featuring Heidelberg offset presses, die-cutting, lamination, and premium finishing — ensures every product meets global standards of quality and creativity.
                    </p>
                    <p className="text-lg text-gray-700 mb-6">
                        From design to delivery, we help your brand stand out with packaging that performs as beautifully as it looks.
                    </p>

                    <Link
                        to="/contact"
                        className="inline-flex items-center px-6 py-3 text-lg font-semibold text-white bg-blue-900 rounded-lg shadow hover:bg-blue-800 transition-transform duration-300 group"
                    >
                        Contact Us
                        <svg
                            className="w-5 h-5 ml-3 transition-transform transform group-hover:translate-x-1"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                clipRule="evenodd"
                            ></path>
                        </svg>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Intro;